// extracted by mini-css-extract-plugin
export default {"PhotoTitleEditForm__submitBtn":"iy_a bie_ss","PhotoTitleEditForm__cancelBtn":"iy_b bie_sw bie_sv"};